import { DayOfWeek as a } from "@ancon/wildcat-types";
const d = {
  0: a.Everyday,
  1: a.Monday,
  2: a.Tuesday,
  3: a.Wednesday,
  4: a.Thursday,
  5: a.Friday,
  6: a.Saturday,
  7: a.Sunday
};
export {
  d as DaysOfWeekMap
};
